import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';
import { GlobalName } from '../utils/global-name';
import { LocalStorageService } from '../utils/local-stoarge-service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  url :string =ConfigService.toApiUrl("v1");
  //url :string =ConfigService.toFile('');

  constructor(private appLocalStorage: LocalStorageService, private http:HttpClient) { }


  getJWTToken(){
    return this.appLocalStorage.get(GlobalName.tokenName)
  }
  setJWTToken(token:any){
    return this.appLocalStorage.set(GlobalName.tokenName,token)
  }
  setJWTRefreshToken(token:any){
    return this.appLocalStorage.set(GlobalName.refreshTokenName,token)
  }

  me(){
    return this.http.get<any>(`${this.url}/user`,
     ConfigService.httpHeader(null,true));
  }

  login(ressource:any){

    /*ressource['grant_type']=LoginParamProd.grantType;
    ressource['client_id']=LoginParamProd.clientId;
    ressource['client_secret']=LoginParamProd.clientSecret;
    ressource['scope']=LoginParamProd.scope;*/

    return this.http.post<any>(`${this.url}/admin/auth/login`, ressource,
     ConfigService.httpHeader(null,true));
  }

  sendMail(ressource:any){
    return this.http.post<any>(`${this.url}/send-reset-password-link`, ressource,
     ConfigService.httpHeader(null,true));
  }


  
  update(ressource:any){
    return this.http.post<any>(`${this.url}/update-profile`, ressource,
     ConfigService.httpHeader(null,true));
  }

  recoverPassword(token:any,ressource:any){
    return this.http.post<any>(`${this.url}/recovery-password/${token}`, ressource,
     ConfigService.httpHeader(null,true));
  }


  logout(){
    return this.http.get<any>(`${this.url}/logout`);
  }

  changePassword(ressource:any){

    return this.http.post<any>(`${this.url}/change-password`, ressource,
    ConfigService.httpHeader(null,true));
    }

    upWallet(ressource:any){
    return this.http.post<any>(`${this.url}/user-wallet`, ressource,
    ConfigService.httpHeader(null,true));
    }


    resetPassword(ressource:any){

      return this.http.post<any>(`${this.url}/reset-password`, ressource,
      ConfigService.httpHeader(null,true));
      }

    changeFirstPassword(ressource:any){

    return this.http.post<any>(`${this.url}/change-first-password`, ressource,
    ConfigService.httpHeader(null,true));
    }

    saveDB(){

      return this.http.get<any>(`${this.url}/save-db`,
      ConfigService.httpHeader(null,true));
      }

      getBackups(){

        return this.http.get<any>(`${this.url}/backups`,
        ConfigService.httpHeader(null,true));
        }
}
